/* global $ */

const PROFESSION_CAROUSEL_SELECTOR = '.js-profession-carousel'

export default class ProfessionCarouselWidget {
  constructor() {
    $(PROFESSION_CAROUSEL_SELECTOR).slick({
      lazyLoad: 'progressive',
      slidesToShow: 3,
      variableWidth: true,
      centerMode: true,
      responsive: [
        {
          breakpoint: 1800,
          settings: {
            slidesToShow: 3,
            centerMode: false
          }
        },
        {
          breakpoint: 1200,
          settings: {
            arrows: false,
            slidesToShow: 3,
            centerMode: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            centerMode: true,
            arrows: false
          }
        }
      ]
    })
  }
}
